import { create } from 'zustand';

import type { PendingAIImage } from '@/types/image';

export type PendingImageStatus = NonNullable<PendingAIImage['status']>;

export type PendingImage = PendingAIImage & {
  status: PendingImageStatus;
};

interface PendingImagesStore {
  pendingImages: Map<string, PendingImage>;
  addPendingImage: (runId: string) => void;
  updatePendingImage: (runId: string, updates: Partial<PendingImage>) => void;
  removePendingImage: (runId: string) => void;
  getPendingImageByRunId: (runId: string) => PendingImage | undefined;
  reset: () => void;
}

export const usePendingImagesStore = create<PendingImagesStore>((set, get) => ({
  pendingImages: new Map(),

  addPendingImage: (runId) => {
    set((state) => {
      const newMap = new Map(state.pendingImages);
      newMap.set(runId, {
        runId,
        status: 'pending',
      });
      return { pendingImages: newMap };
    });
  },

  updatePendingImage: (runId, updates) => {
    set((state) => {
      const existing = state.pendingImages.get(runId);
      if (!existing) {
        return state;
      }

      const newMap = new Map(state.pendingImages);
      const updated = { ...existing, ...updates };
      newMap.set(runId, updated);
      return { pendingImages: newMap };
    });
  },

  removePendingImage: (runId) => {
    set((state) => {
      const newMap = new Map(state.pendingImages);
      newMap.delete(runId);
      return { pendingImages: newMap };
    });
  },

  getPendingImageByRunId: (runId) => {
    return get().pendingImages.get(runId);
  },

  reset: () => {
    set({ pendingImages: new Map() });
  },
}));
